import { render, staticRenderFns } from "./ReportFinanceMarginReport.vue?vue&type=template&id=7adf3306"
import script from "./ReportFinanceMarginReport.vue?vue&type=script&lang=js"
export * from "./ReportFinanceMarginReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports